import * as jose from 'jose';

export const createTestPiranhaToken = (spId = 'SP301', lcId = '4711') => {
  const secret = 'ach-wie-gut-dass-niemand-weiss-9';
  const nowSec = Math.floor(Date.now() / 1000);
  const header = { alg: 'HS256', kid: 'test' };
  const payload = {
    iss: 'http://fake.issuer.for.coms.simulator.telefonica.de',
    iat: nowSec,
    exp: nowSec + 3600, // 1h
    sub: 'fake-customer',
    aud: 'coms.api.4p',
    scope: ['openid', `consent.${spId}.${lcId}.write`, `consent.${spId}.${lcId}.read`],
    tefUserAssets: [{
      tefCustomers: [{
        customerId: lcId,
        role: ['OWNER'],
        spId,
        stack: 'RCS',
        tefAccounts: [{
          billingAccountId: '6000167774',
          tefSubscriptions: [{
            assetType: 'MOBILE',
            id: '26724096806345022282520',
            msisdn: '4917642031774',
            role: ['USER', 'PERSONAL'],
            subscriptionId: '2148140849',
            tariff_type: 'POSTPAID',
          }],
        }],
      }],
    }],
  };
  const secretEncoded = new TextEncoder().encode(secret);
  return new jose.SignJWT(payload).setProtectedHeader(header).sign(secretEncoded);
};
